import { find as _find } from 'lodash'

const mutations = {
    selectCompany (state, companyId) {
        state.selectedCompany = _find(state.companies, { id: companyId })
    },
}

export default mutations
